import { forwardRef } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";

import {
  SHEET_DESCRIPTION_DEFAULTS,
  SHEET_TYPOGRAPHY_ALIGN_PROPS,
  type TSheetDescriptionElement,
  type TSheetDescriptionProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { TextBody } from "../../typography/TextBody";
import { cn } from "@/ui/lib";

export const SheetDescription = forwardRef<TSheetDescriptionElement, TSheetDescriptionProps>(
  (
    {
      children,
      align = SHEET_DESCRIPTION_DEFAULTS.align,
      ...props
    },
    ref,
  ) => (
    <SheetPrimitive.Description
      data-component="SheetDescription"
      ref={ref}
      className={cn(
        "text-foreground-muted-strong",
      )}
      {...props}
    >
      <TextBody
        tag="span"
        size={2}
        isResponsive={false}
        color="inherit"
        align={SHEET_TYPOGRAPHY_ALIGN_PROPS[align]}
        className="block"
      >
        { children }
      </TextBody>
    </SheetPrimitive.Description>
  ),
);

SheetDescription.displayName = SheetPrimitive.Description.displayName;
